import { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  CircularProgress,
  Box
} from '@mui/material'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'
import css from './ModalPdfViewer.module.css'

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

const ModalPdfViewer = ({ open, onClose, title, pdfUrl }) => {
  const [numPages, setNumPages] = useState(null)
  const [pageWidth, setPageWidth] = useState(null)
  const [isZoomedIn, setIsZoomedIn] = useState(false)

  useEffect(() => {
    const updateWidth = () => {
      // Calculate optimal page width based on container
      const container = document.querySelector(`.${css.content}`)
      if (container) {
        const maxWidth = container.offsetWidth - 32
        const defaultWidth = 600
        setPageWidth(isZoomedIn ? maxWidth : defaultWidth)
      }
    }

    if (open) {
      updateWidth()
      window.addEventListener('resize', updateWidth)
      return () => window.removeEventListener('resize', updateWidth)
    }
  }, [open, isZoomedIn])

  const handleZoomToggle = () => {
    setIsZoomedIn(!isZoomedIn)
  }

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
  }

  const handleContextMenu = e => {
    e.preventDefault()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle className={css.title}>
        {title}
        <Box className={css.controls}>
          <IconButton
            onClick={handleZoomToggle}
            size='small'
            title={isZoomedIn ? 'Zoom out' : 'Zoom in'}
          >
            <i className='material-icons'>
              {isZoomedIn ? 'zoom_out' : 'zoom_in'}
            </i>
          </IconButton>
          <IconButton
            onClick={onClose}
            size='small'
            className={css.closeButton}
          >
            <i className='material-icons'>close</i>
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={css.content} onContextMenu={handleContextMenu}>
        <div className={css.pdfContainer}>
          <Document
            file={pdfUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={
              <Box className={css.loading}>
                <CircularProgress />
              </Box>
            }
            error={
              <Box className={css.error}>
                No se ha podido cargar el documento.
              </Box>
            }
            className={css.document}
          >
            {Array.from(new Array(numPages), (_, index) => (
              <Page
                key={`page-${index}`}
                width={pageWidth}
                pageNumber={index + 1}
                renderTextLayer={false}
                renderAnnotationLayer={true}
                loading='Cargando página...'
              />
            ))}
          </Document>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ModalPdfViewer
